import cn from 'classnames';
import * as React from 'react';
import { IResultPriceWithCurrency } from '../../types/shell';

import { BagCount, Price } from '../index';

import styles from './BucketTotal.module.scss';

interface IProps {
  total: IResultPriceWithCurrency;
  onClick?: () => void;
  count: number;
  className?: string;
}

const BucketTotal = ({ className, count, onClick, total }: IProps) => {
  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.price}>
        Total price: <Price value={total} className={styles.value} amountClassName={styles.amount} />
      </div>
      <div className={styles.items}>
        <div className={styles.title}>Added items:</div>
        <BagCount count={count} onClick={onClick} />
      </div>
    </div>
  );
};

export default BucketTotal;
